var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tag)?_c('span',{staticClass:"produto-tag",class:[`produto-tag-${_vm.tag.id}`, {'produto-tag-compacta': _vm.variant === 'compacta'}]},[_vm._v(" "+_vm._s(_vm.tag.label)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }